import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const ADD_PRODUCT_POSITION_CUSTOM_MUTATION = gql`
  mutation customAddProductLine(
    $documentVersion: DocumentVersionInput!,
    $productId: String!
  ) {
    custom {
      customAddProductLine(
        documentRevision: $documentVersion
        productId: $productId
      ) {
        newLines {
          id
          customProperties {
            key
            stringValue
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class AddProductPositionCustomMutation extends Mutation<RootMutation> {
  document = ADD_PRODUCT_POSITION_CUSTOM_MUTATION;
}
